module.exports = __webpack_public_path__ + "img/home6.361e3842.png";